import { CheckboxGroupFilter, FilterSection } from 'components/data-table';
import type { ColumnFiltersState } from '@tanstack/react-table';
import styles from './filter-panel-content.module.scss';

interface Option {
  key: string;
  label: string;
}

interface Props {
  documentTypes: Option[];
  agents: Option[];
  columnFilters: ColumnFiltersState;
  setColumnFilters: (filters: ColumnFiltersState) => void;
}

export function FilterPanelContent({
  documentTypes,
  agents,
  columnFilters,
  setColumnFilters,
}: Props) {
  // Both sections drive the single `label` column filter, keyed on group key.
  const selected =
    (columnFilters.find((f) => f.id === 'label')?.value as string[]) ?? [];

  // The section's own selection, and a setter that merges it back with the other
  // section's keys so the two groups share one column filter without clobbering.
  const selectedIn = (options: Option[]) =>
    selected.filter((k) => options.some((o) => o.key === k));

  const setSection = (options: Option[]) => (next: string[]) => {
    const keys = options.map((o) => o.key);
    const merged = [...selected.filter((k) => !keys.includes(k)), ...next];
    const others = columnFilters.filter((f) => f.id !== 'label');
    setColumnFilters(
      merged.length ? [...others, { id: 'label', value: merged }] : others
    );
  };

  const toOptions = (options: Option[]) =>
    options.map((o) => ({ value: o.key, label: o.label }));

  return (
    <>
      <div className={styles.section}>
        <FilterSection title="Document Types">
          <CheckboxGroupFilter
            id="filter-document-types"
            value={selectedIn(documentTypes)}
            onChange={setSection(documentTypes)}
            options={toOptions(documentTypes)}
          />
        </FilterSection>
      </div>
      <div className={styles.section}>
        <FilterSection title="Agents">
          <CheckboxGroupFilter
            id="filter-agents"
            value={selectedIn(agents)}
            onChange={setSection(agents)}
            options={toOptions(agents)}
          />
        </FilterSection>
      </div>
    </>
  );
}
